import type { InputHTMLAttributes } from "react";
import "./FormControls.scss";

type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  label?: string;
};

export function Checkbox({ className = "", label, ...props }: CheckboxProps) {
  return (
    <label className="form-check">
      <input className={`form-check-control ${className}`.trim()} type="checkbox" {...props} />
      {label && <span>{label}</span>}
    </label>
  );
}
